import './TipsAttach.sass';

import React, { FC } from 'react';

import { TipsAttachProps } from '$shared/components/TipsAttach/TipsAttach.interface';
import { useTranslator } from '$hooks';
import { showModal } from '$navigation/helper';
import { Button } from '$uikit';

export const TipsAttach: FC<TipsAttachProps> = ({ tips }) => {
  const t = useTranslator();

  return (
    <div className="TipsAttach">
      <div className="TipsAttach__amount">
        {tips.amount} {tips.currency ? tips.currency.toUpperCase() : 'TON'}
      </div>
      <div className="TipsAttach__caption">{t('tips_attach_caption')}</div>
      {tips.postId > 0 && (
        <div className="TipsAttach__post_btn">
          <Button
            size="small"
            mode="tertiary"
            onClick={(e) => {
              e.preventDefault();
              showModal(`post${tips.postId}`);
            }}
          >
            {t('ads_view_open_post')}
          </Button>
        </div>
      )}
    </div>
  );
};
